(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wynch-catalog-set-interleave]';
  var LIST_SELECTOR = '.product-card-list.boost-pfs-filter-products';
  var CARD_SELECTOR = ':scope > .product-card';
  var POOL_SELECTOR = '[data-wynch-catalog-set-pool]';
  var PROMO_CLASS = 'wynch-catalog-set-promo';
  var DOUBLE_CLASS = 'product-card-double';
  var SESSION_KEY = 'wynch_catalog_set_order_v1';
  var DESKTOP_QUERY = '(min-width: 1024px)';

  function positiveInteger(value, fallback) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function productHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      var pathname = new URL(link.href, window.location.origin).pathname;
      var match = pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function shuffledCards(cards) {
    var byHandle = new Map();
    cards.forEach(function (card) {
      var handle = productHandle(card);
      if (handle) byHandle.set(handle, card);
    });

    var storedOrder = [];
    try {
      storedOrder = JSON.parse(window.sessionStorage.getItem(SESSION_KEY) || '[]');
      if (!Array.isArray(storedOrder)) storedOrder = [];
    } catch (error) {
      storedOrder = [];
    }

    var orderedHandles = storedOrder.filter(function (handle) {
      return byHandle.has(handle);
    });
    var newHandles = Array.from(byHandle.keys()).filter(function (handle) {
      return orderedHandles.indexOf(handle) === -1;
    });

    for (var index = newHandles.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var current = newHandles[index];
      newHandles[index] = newHandles[randomIndex];
      newHandles[randomIndex] = current;
    }

    orderedHandles = orderedHandles.concat(newHandles);
    try {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(orderedHandles));
    } catch (error) {
      // A blocked storage API must not prevent the catalog from rendering.
    }

    return orderedHandles.map(function (handle) {
      return byHandle.get(handle);
    });
  }

  function hasActiveRefinement() {
    var params = new URLSearchParams(window.location.search);
    return Array.from(params.keys()).some(function (key) {
      return key === 'sort' || key === 'sort_by' || key.indexOf('pf_') === 0;
    });
  }

  function insertionPlan(wineCount, interval, setCount) {
    var plan = [];
    for (var after = interval; after <= wineCount; after += interval) {
      plan.push({ after: after, count: setCount });
    }
    return plan;
  }

  function CatalogSetInterleaver(root) {
    this.root = root;
    this.poolTemplate = root.querySelector(POOL_SELECTOR);
    this.desktopMedia = window.matchMedia(DESKTOP_QUERY);
    this.scheduled = false;
    this.observer = new MutationObserver(this.schedule.bind(this));
    this.handleViewportChange = this.schedule.bind(this);

    var poolCards = this.poolTemplate
      ? Array.from(this.poolTemplate.content.querySelectorAll('.' + PROMO_CLASS))
      : [];
    this.pool = shuffledCards(poolCards);
  }

  CatalogSetInterleaver.prototype.start = function () {
    if (!this.pool.length) return;
    this.desktopMedia.addEventListener('change', this.handleViewportChange);
    this.observer.observe(this.root, { childList: true, subtree: true });
    this.render();
  };

  CatalogSetInterleaver.prototype.schedule = function () {
    if (this.scheduled) return;
    this.scheduled = true;
    window.requestAnimationFrame(function () {
      this.scheduled = false;
      this.render();
    }.bind(this));
  };

  CatalogSetInterleaver.prototype.render = function () {
    var list = this.root.querySelector(LIST_SELECTOR);
    if (!list) return;

    this.observer.disconnect();

    list.querySelectorAll('.' + PROMO_CLASS).forEach(function (card) {
      card.remove();
    });

    if (hasActiveRefinement()) {
      this.observer.observe(this.root, { childList: true, subtree: true });
      return;
    }

    list.querySelectorAll('.' + DOUBLE_CLASS + ':not(.' + PROMO_CLASS + ')').forEach(function (card) {
      card.remove();
    });

    var wines = Array.from(list.querySelectorAll(CARD_SELECTOR)).filter(function (card) {
      return !card.classList.contains(DOUBLE_CLASS);
    });
    var isDesktop = this.desktopMedia.matches;
    var interval = positiveInteger(
      this.root.dataset[isDesktop ? 'desktopWineInterval' : 'mobileWineInterval'],
      isDesktop ? 8 : 4
    );
    var setCount = positiveInteger(
      this.root.dataset[isDesktop ? 'desktopSetCount' : 'mobileSetCount'],
      isDesktop ? 2 : 1
    );
    var productsPerPage = positiveInteger(this.root.dataset.productsPerPage, 24);
    var page = positiveInteger(new URLSearchParams(window.location.search).get('page'), 1);
    var slotsPerPage = insertionPlan(productsPerPage, interval, setCount).reduce(function (total, slot) {
      return total + slot.count;
    }, 0);
    var poolOffset = ((page - 1) * slotsPerPage) % this.pool.length;
    var poolIndex = 0;

    insertionPlan(wines.length, interval, setCount).forEach(function (slot) {
      var referenceCard = wines[slot.after] || null;
      for (var count = 0; count < slot.count; count += 1) {
        var sourceIndex = (poolOffset + poolIndex) % this.pool.length;
        var promoCard = this.pool[sourceIndex].cloneNode(true);
        promoCard.dataset.wynchCatalogSetPromo = 'true';
        list.insertBefore(promoCard, referenceCard);
        poolIndex += 1;
      }
    }, this);

    this.observer.observe(this.root, { childList: true, subtree: true });
  };

  function initialize(root) {
    if (root.dataset.wynchCatalogSetReady === 'true') return;
    root.dataset.wynchCatalogSetReady = 'true';
    new CatalogSetInterleaver(root).start();
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  }

  window.WynchCatalogSetInterleave = {
    insertionPlan: insertionPlan,
    initializeAll: initializeAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
